// extracted by mini-css-extract-plugin
export default {"container":"container-e62NJ","image":"image-fVhcv"};